module.exports = __webpack_public_path__ + "static/media/logo-header-darkbg.1135ac7d.svg";